import React from 'react';
import {
  Route,
  BrowserRouter as Router,
  Switch,
  Redirect,
} from 'react-router-dom';

import SignUp from './containers/SignUp';
import SignIn from './containers/SignIn';
import Checkout from './containers/Checkout';
import ThankyouPage from './containers/ThankyouPage';
import Home from './containers/Home';
import NewSignRiderWizard from './containers/NewSignRiderWizard';
import NotFound from './components/NotFound';
import AppliedRoute from './components/AppliedRoute';
import ForgotPassword from './components/ForgotPassword';

export default ({ childProps }) => {
  return (
    <Router>
      <Switch>
        <AppliedRoute
          path="/signup/:plan"
          exact
          component={SignUp}
          props={childProps}
        />
        <AppliedRoute
          path="/signin"
          exact
          component={SignIn}
          props={childProps}
        />
        <AppliedRoute
          path="/forgot-password"
          exact
          component={ForgotPassword}
          props={childProps}
        />
        <AppliedRoute
          path="/checkout"
          exact
          component={Checkout}
          props={childProps}
        />
        <AppliedRoute
          path="/thank-you"
          exact
          component={ThankyouPage}
          props={childProps}
        />
        <AppliedRoute
          path="/home/new-signrider"
          exact
          component={NewSignRiderWizard}
          props={childProps}
        />
        <AppliedRoute path="/home" component={Home} props={childProps} />
        <Redirect exact from="/" to="/home" />
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};



// WEBPACK FOOTER //
// ./src/Routes.js